module.exports = __webpack_public_path__ + "img/add.0f50b39f.png";